var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.$t('MAKE_RESERVATION.RECURRENCE.' + _vm.type, {day: _vm.getDay, number: _vm.getOrdinal, dayNumber: _vm.getDayNumber, month: _vm.getMonth})))])
}
var staticRenderFns = []

export { render, staticRenderFns }